<template>
  <div v-loading.body="loading">
    <div class="c_page-title">
      <div>错误操作记录列表</div>
      <el-button
        class="icon-fresh"
        size="mini"
        icon="el-icon-refresh"
        @click="fetchData(true)"
        >刷新</el-button
      >
    </div>
    <el-row class="filter">
      <el-col>
        <div
          style="
            background: #f3f3f3;
            height: 30px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>查询搜索</div>
          <el-button
            type="text"
            style="margin-left: auto"
            :icon="filterFold ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
            @click="toggleFilter"
          >
            {{ filterFold ? "展开筛选" : "收起筛选" }}
          </el-button>
        </div>
        <el-collapse-transition>
          <div v-show="!filterFold">
            <div style="padding: 10px 25px">
              <el-form
                :inline="true"
                :model="form"
                class="demo-form-inline"
                @keyup.native.enter="search"
              >
                <el-form-item>
                  <el-select v-model="form.tache" placeholder="错误环节">
                    <el-option value="" label="全部"></el-option>
                    <el-option
                      v-for="item in tacheOptions"
                      :key="item.key"
                      :value="item.key"
                      :label="item.label"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-input
                    v-model="form.main_param"
                    placeholder="请输入主单号"
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <el-input
                    v-model="form.secondary_param"
                    placeholder="请输入次要的查询数据"
                  ></el-input>
                </el-form-item>
                <el-form-item label="操作时间">
                  <el-date-picker
                    v-model="form.create_time"
                    type="datetimerange"
                    :default-time="['06:00:00', '06:00:00']"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    style="width: 370px"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="search">查询</el-button>
                  <el-button type="primary" @click="reset">重置</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </el-collapse-transition>
      </el-col>
    </el-row>
    <el-row class="filter">
      <el-col style="border: 1px solid #ddd">
        <div
          style="
            background: #f3f3f3;
            height: 50px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>数据列表：</div>
          <el-button
            style="margin-left: auto"
            type="success"
            size="mini"
            @click="output"
            >导出</el-button
          >
        </div>
        <div v-if="list" style="margin-bottom: 0">
          <el-table
            ref="multipleTable"
            height="600"
            :data="list"
            tooltip-effect="dark"
            style="width: 100%"
          >
            <el-table-column
              prop="id"
              label="序号"
              align="center"
              width="50"
            ></el-table-column>
            <el-table-column
              prop="tache_name"
              label="环节"
              align="center"
              width="50"
            ></el-table-column>
            <el-table-column
              prop="error_msg"
              label="错误信息"
              align="center"
              width=""
            ></el-table-column>
            <el-table-column
              prop="main_param_text"
              label="主参数"
              align="center"
              width=""
            >
            </el-table-column>
            <el-table-column
              prop="secondary_param_text"
              label="次参数"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="other_params"
              label="其他参数"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="admin_name"
              label="操作人"
              align="center"
              width="80"
            ></el-table-column>
            <el-table-column
              prop="create_time"
              label="操作时间"
              align="center"
            ></el-table-column>
          </el-table>
        </div>
        <div v-if="list" style="text-align: right; padding: 25px">
          <el-pagination
            :current-page.sync="form.page"
            :page-sizes="[50, 100]"
            background
            layout="total, sizes, prev, pager, next, jumper"
            :total="count"
            :page-size="form.psize"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
          >
          </el-pagination>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fetchData();
    });
  },
  data() {
    return {
      loading: false,
      filterFold: false,
      form: {
        tahce: 0,
        create_time: this.defaultDate(-5),
        page: 1,
        psize: 50,
        origin: 1,
      },
      list: [],
      tacheOptions: [],
      count: 0,
    };
  },
  computed: {
    filteredForm() {
      for (const key in this.form) {
        if (
          this.form[key] === undefined ||
          this.form[key] === "" ||
          this.form[key] === null
        ) {
          delete this.form[key];
        }
      }
      return this.form;
    },
  },
  methods: {
    search() {
      this.form.page = 1;
      this.form.task = 0;
      this.fetchData(false);
    },
    reset() {
      this.form = {
        tahce: 0,
        create_time: this.defaultDate(-5),
        page: 1,
        psize: 50,
        task: 0,
      };
      this.fetchData(true);
    },
    handleCurrentChange(page) {
      this.form.page = page;
      this.form.task = 0;
      this.fetchData(true);
    },
    handleSizeChange(pszie) {
      this.form.page = 1;
      this.form.psize = pszie;
      this.form.task = 0;
      this.fetchData(true);
    },
    toggleFilter() {
      this.filterFold = !this.filterFold;
    },
    defaultDate(range) {
      return this.$excalibur.getDateTimeOnHours(range, 24);
    },
    fetchData(isExport = false) {
      this.$http
        .post("/erp/InterFaceLog/lst", {
          ...this.filteredForm,
          task: isExport ? 1 : 0,
        })
        .then((res) => {
          if (res.data.code != 200) {
            this.$message.error(res.data.msg);
          }
          if (isExport) {
            this.$message.success("成功提交导出任务");
          } else {
            this.list = res.data.data.list;
            this.page = res.data.data.page;
            this.psize = res.data.data.psize;
            this.tacheOptions = res.data.data.option.tacheOptions;
            this.count = res.data.data.count;
          }
        });
    },
    output() {
      this.fetchData(true);
    },
  },
};
</script>
<style scoped>
.row {
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/pages/log/ErpErrorLog.vue